module.exports = __webpack_public_path__ + "img/metamask.a392439b.png";